export const line_heights = {
  title: "28px",
  copy: "20px",
}

export const space = ["0px", "4px", "8px", "16px", "32px", "64px"]
